import CommonApplication from "../common/Application";
import Routes from "./config/Routes";
import UnreadNotificationCenter from "../shared/UnreadNotificationCenter";

export default class Application extends CommonApplication{
    constructor() {
        super();
        this.routes = new Routes();
    }

    loadLibraries() {
        if(this.datatable !== null){
            this.datatable.destroy();
        }
        this.datatable = $('.datatable').DataTable({
            language: require('../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
            columnDefs: [
                { orderable: false, searchable: false, targets: -1 }
            ]
        })
        if(this.exportdatatable !== null){
            this.exportdatatable.destroy();
        }
        this.exportdatatable = $('.exportdatatable').DataTable({
            language: require('../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
            order: [[0, 'desc']],
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            dom: 'Bfrtip',
            buttons: [
                'csv',
                'pageLength'
            ]
        })
    }

    setupUnreadNotifications(){
        this.unreadNotifications = new UnreadNotificationCenter({
            containerSelector: '#bo-unread-comments',
            modalSelector: '#unreadNotificationsModal',
            listSelector: '#unread-notifications-list',
            loaderSelector: '#unread-notifications-loader',
            emptySelector: '#unread-notifications-empty',
            totalSelector: '#unread-notifications-total',
            markAllSelector: '#unread-notifications-mark-all',
            ownerFilterSelector: '#unread-notifications-owner-filter',
            onError: (message) => {
                if (message && message.length > 0) {
                    this.errorNotification(message);
                }
            }
        });
    }
}